export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4777.d3b60beb.jpg";